/** Plots a line on dots, adapted from https://goo.gl/kRNrMR */
// used to convert drawing into array for neataptic 
function plot (x0, y0, x1, y1) {
  if (x0 === x1 && y0 === y1) {
    return [];
  }

  var fraction = function (x) {
    return x - Math.floor(x);
  };

  var dots = [];
  var steep = Math.abs(y1 - y0) > Math.abs(x1 - x0);

  if (steep) {
    [y0, x0] = [x0, y0];
    [y1, x1] = [x1, y1];
  }

  if (x0 > x1) {
    [x1, x0] = [x0, x1];
    [y1, y0] = [y0, y1];
  }

  var dx = x1 - x0;
  var dy = y1 - y0;
  var gradient = dy / dx;

  var xEnd = Math.round(x0);
  var yEnd = y0 + gradient * (xEnd - x0);
  var xGap = 1 - fraction(x0 + 0.5);
  var xPx1 = xEnd;
  var yPx1 = Math.floor(Math.abs(yEnd));

  if (steep) {
    dots.push({ x: yPx1, y: xPx1, b: 1 - fraction(yEnd) * xGap });
    dots.push({ x: yPx1 + 1, y: xPx1, b: fraction(yEnd) * xGap });
  } else {
    dots.push({ x: xPx1, y: yPx1, b: 1 - fraction(yEnd) * xGap });
    dots.push({ x: xPx1, y: yPx1 + 1, b: fraction(yEnd) * xGap });
  }

  var intery = yEnd + gradient;

  xEnd = Math.round(x1);
  yEnd = y1 + gradient * (xEnd - x1);
  xGap = fraction(x1 + 0.5);

  var xPx2 = xEnd;
  var yPx2 = Math.floor(Math.abs(yEnd));

  if (steep) {
    dots.push({ x: yPx2, y: xPx2, b: 1 - fraction(yEnd) * xGap });
    dots.push({ x: yPx2 + 1, y: xPx2, b: fraction(yEnd) * xGap });
  } else {
    dots.push({ x: xPx2, y: yPx2, b: 1 - fraction(yEnd) * xGap });
    dots.push({ x: xPx2, y: yPx2 + 1, b: fraction(yEnd) * xGap });
  }

  if (steep) {
    for (let x = xPx1 + 1; x <= xPx2 - 1; x++) {
      dots.push({ x: Math.floor(Math.abs(intery)), y: x, b: 1 - fraction(intery) });
      dots.push({ x: Math.floor(Math.abs(intery)) + 1, y: x, b: fraction(intery) });
      intery = intery + gradient;
    }
  } else {
    for (let x = xPx1 + 1; x <= xPx2 - 1; x++) {
      dots.push({ x: x, y: Math.floor(Math.abs(intery)), b: 1 - fraction(intery) });
      dots.push({ x: x, y: Math.floor(Math.abs(intery)) + 1, b: fraction(intery) });
      intery = intery + gradient;
    }
  }

  return dots;
}

/** Converts the strokes of a drawing to an array */
export function drawingToArray (data, size=28) {
  // console.log(data);
  var bitmap = new Array(size * size).fill(0);

  for (let i = 0; i < data.length; i++) {
    let stroke = data[i];
    for (var j = 1; j < stroke[0].length; j++) {
      let dots = plot(
        stroke[0][j - 1] * size / 256,
        stroke[1][j - 1] * size / 256,
        stroke[0][j] * size / 256,
        stroke[1][j] * size / 256
      );

      for (var k = 0; k < dots.length; k++) {
        let dot = dots[k];
        if (dot.y < size && dot.x < size) {
          bitmap[dot.y * size + dot.x] += dot.b;
        }
      }
    }
  }

  for (let i = 0; i < bitmap.length; i++) {
    if (bitmap[i] > 1) {
      bitmap[i] = 1;
    } else {
      bitmap[i] = Math.round(bitmap[i] * 1000) / 1000;
    }
  }

  return bitmap;
}

export function normalize (drawing) {
  // normalize a drawing to ints 0 - 255
  // find min max across all x posns in all strokes

  // drawing array:
  // [ 
  //   [  // First stroke 
  //     [x0, x1, x2, x3, ...],
  //     [y0, y1, y2, y3, ...],
  //   ],
  //   [  // Second stroke
  //     [x0, x1, x2, x3, ...],
  //     [y0, y1, y2, y3, ...],
  //   ],
  //   ... // Additional strokes
  // ]

  var minX = Infinity;
  var minY = Infinity;
  var maxX = -Infinity;
  var maxY = -Infinity;

  // find range of xy
  for (let i = 0; i < drawing.length; i++) {
    let stroke = drawing[i];
    for (let j = 0; j < stroke[0].length; j++) {
      let x = stroke[0][j];
      let y = stroke[1][j];

      // console.log(x, y);
      
      if (x < minX) minX = x;
      if (y < minY) minY = y;
      if (x > maxX) maxX = x;
      if (y > maxY) maxY = y;    

    }
  }
  
  // console.log("minX: ", minX);
  // console.log("maxX: ", maxX);
  // console.log("minY: ", minY);
  // console.log("maxY: ", maxY);

  var rangeX = maxX - minX;
  var rangeY = maxY - minY;

  // normalize each point
  for (let i = 0; i < drawing.length; i++) {
    let stroke = drawing[i];
    for (let j = 0; j < stroke[0].length; j++) {
      stroke[0][j] = Math.round((stroke[0][j] - minX) * (255.0 / rangeX));
      stroke[1][j] = Math.round((stroke[1][j] - minY) * (255.0 / rangeY));
    }
  }
  return drawing;
}
